import React from 'react';

function UserPaymentsIcon() {
    return (
        <svg
            strokeWidth="0"
            viewBox="0 0 24 24"
            height="40"
            width="30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className='list-svg-icon fill-red'
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16
                 c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
            />
        </svg>
    );
}

export default UserPaymentsIcon;
